import {FLOOR_TYPES} from "../../../constants/floorTypes";

// Derive available floor types for each dropdown based on floors above
export const getAvailableFloorTypes = (floors, currentFloorIndex) => {
    const selectedTypes = floors
      .slice(0, currentFloorIndex)
      .map(f => f.floorType)
      .filter(t => t !== FLOOR_TYPES.UNKNOWN.value);

    let available = { ...FLOOR_TYPES };

    if (selectedTypes.includes(FLOOR_TYPES.GROUND_FLOOR.value)) {
      delete available[FLOOR_TYPES.BASEMENT_FLOOR.value];
      delete available[FLOOR_TYPES.GROUND_FLOOR.value];
    }
    if (selectedTypes.includes(FLOOR_TYPES.HIGH_NORMAL_FLOOR.value)) {
      delete available[FLOOR_TYPES.BASEMENT_FLOOR.value];
      delete available[FLOOR_TYPES.GROUND_FLOOR.value];
      delete available[FLOOR_TYPES.HIGH_NORMAL_FLOOR.value];
    }
    if (selectedTypes.includes(FLOOR_TYPES.NORMAL_FLOOR.value)) {
      delete available[FLOOR_TYPES.BASEMENT_FLOOR.value];
      delete available[FLOOR_TYPES.GROUND_FLOOR.value];
      delete available[FLOOR_TYPES.HIGH_NORMAL_FLOOR.value];
    }
    if (selectedTypes.includes(FLOOR_TYPES.MEZZANINE_FLOOR.value) || selectedTypes.includes(FLOOR_TYPES.MAISONETTE.value)) {
      delete available[FLOOR_TYPES.BASEMENT_FLOOR.value];
      delete available[FLOOR_TYPES.GROUND_FLOOR.value];
      delete available[FLOOR_TYPES.HIGH_NORMAL_FLOOR.value];
    }
    if (selectedTypes.includes(FLOOR_TYPES.ATTIC_FLOOR.value)) {
      delete available[FLOOR_TYPES.ATTIC_FLOOR.value];
    }

    return available;
  };